import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import VideoIntro from "./pages/VideoIntro";
import Index from "./pages/Index";
import VideoStep1 from "./pages/VideoStep1";
import VideoStep2 from "./pages/VideoStep2";
import VideoStep3 from "./pages/VideoStep3";
import VideoStep4 from "./pages/VideoStep4";
import VideoStep5 from "./pages/VideoStep5";
import VideoStep6 from "./pages/VideoStep6";
import ThankYou from "./pages/ThankYou";
import Community from "./pages/Community";
import SubmissionLogs from "./pages/SubmissionLogs";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<VideoIntro />} />
          <Route path="/2" element={<Index />} />
          <Route path="/3" element={<VideoStep6 />} />
          <Route path="/community" element={<Community />} />
          <Route path="/4" element={<VideoStep1 />} />
          <Route path="/5" element={<VideoStep2 />} />
          <Route path="/6" element={<VideoStep3 />} />
          <Route path="/7" element={<VideoStep4 />} />
          <Route path="/8" element={<VideoStep5 />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/logs" element={<SubmissionLogs />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
